import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../components/Navbar'

export default function EditExercise() {
  const { exerciseId } = useParams()
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [instructions, setInstructions] = useState('')
  const [file, setFile] = useState(null)
  const [videoUrl, setVideoUrl] = useState('')
  const [videoError, setVideoError] = useState('')
  const [mediaUrl, setMediaUrl] = useState(null)
  const [uploading, setUploading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => { fetchExercise() }, [])

  async function fetchExercise() {
    const { data } = await supabase.from('exercises').select('*').eq('id', exerciseId).single()
    if (data) {
      setTitle(data.title || '')
      setDescription(data.description || '')
      setInstructions(data.instructions || '')
      setVideoUrl(data.video_url || '')
      setMediaUrl(data.media_url || null)
    }
    setLoading(false)
  }

  function isValidYouTubeUrl(url) {
    if (!url) return true
    return /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)/.test(url)
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setVideoError('')
    if (videoUrl && !isValidYouTubeUrl(videoUrl)) {
      setVideoError('Please enter a valid YouTube URL')
      return
    }
    setUploading(true)
    setError('')
    let media_url = mediaUrl

    if (file) {
      const ext = file.name.split('.').pop()
      const filename = Date.now() + '.' + ext
      const { error: uploadError } = await supabase.storage.from('exercises').upload(filename, file)
      if (uploadError) { setError(uploadError.message); setUploading(false); return }
      const { data: urlData } = supabase.storage.from('exercises').getPublicUrl(filename)
      media_url = urlData.publicUrl
    }

    const { error: updateError } = await supabase.from('exercises').update({
      title, description, instructions, media_url, video_url: videoUrl || null
    }).eq('id', exerciseId)

    if (updateError) { setError(updateError.message); setUploading(false); return }
    navigate('/clinician/exercises')
  }

  async function handleRemoveMedia() {
    setMediaUrl(null)
    await supabase.from('exercises').update({ media_url: null }).eq('id', exerciseId)
  }

  if (loading) return <><Navbar /><div className="page"><p>Loading...</p></div></>

  return (
    <>
      <Navbar />
      <div className="page">
        <span onClick={() => navigate('/clinician/exercises')} className="back-link" style={{ cursor: 'pointer' }}>← Exercise library</span>
        <div className="page-header">
          <h1>Edit exercise</h1>
          <p>Update the details for this exercise</p>
        </div>

        {error && <div className="alert-error" style={{ marginBottom: '1.5rem' }}>{error}</div>}

        <div className="card">
          <form onSubmit={handleSubmit} className="form-group">
            <div className="form-field">
              <label className="form-label">Exercise title</label>
              <input placeholder="e.g. Clamshell" value={title} onChange={e => setTitle(e.target.value)} required />
            </div>
            <div className="form-field">
              <label className="form-label">Short description</label>
              <textarea placeholder="Brief summary of the exercise" value={description} onChange={e => setDescription(e.target.value)} rows={2} style={{ resize: 'vertical' }} />
            </div>
            <div className="form-field">
              <label className="form-label">Step-by-step instructions</label>
              <textarea placeholder="1. Lie on your side with knees bent..." value={instructions} onChange={e => setInstructions(e.target.value)} rows={5} style={{ resize: 'vertical' }} />
            </div>
            <div className="form-field">
              <label className="form-label">Image (optional)</label>
              {mediaUrl && (
                <div style={{ marginBottom: 8 }}>
                  <img src={mediaUrl} alt="Current" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }} />
                  <button type="button" className="danger" onClick={handleRemoveMedia}>Remove image</button>
                </div>
              )}
              <input type="file" accept="image/png,image/jpeg" onChange={e => setFile(e.target.files[0])} />
              <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 4 }}>PNG or JPG recommended</p>
            </div>
            <div className="form-field">
              <label className="form-label">YouTube video URL (optional)</label>
              <input
                type="url"
                placeholder="https://youtube.com/watch?v=..."
                value={videoUrl}
                onChange={e => setVideoUrl(e.target.value)}
              />
              {videoError && <p style={{ fontSize: 12, color: 'var(--danger)', marginTop: 4 }}>{videoError}</p>}
              <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 4 }}>Patients will see a Watch video link on their dashboard</p>
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
              <button type="submit" disabled={uploading} style={{ flex: 1, padding: 14 }}>
                {uploading ? 'Saving...' : 'Save changes'}
              </button>
              <button type="button" className="secondary" onClick={() => navigate('/clinician/exercises')} style={{ padding: 14 }}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}